import { usePlatformFeatureFlag } from "@datassential/platform-ui-lib";
import { FOOD_PROFILE_REFRESH_FLAG } from "@pages/Food/Food.constants";

/** Single switch for every Food Profile refresh change, so retiring the flag is one search away. */
export default function useFoodProfileRefresh() {
    return usePlatformFeatureFlag(FOOD_PROFILE_REFRESH_FLAG);
}
